import type {InventoryPlot} from '@/domain/entities/InventoryPlot';
import type {InventoryPLotDto} from './InventoryPLotDto';

export const toDto = (domain: InventoryPlot): InventoryPLotDto => ({
  uuid: domain.uuid,
  forestMassSpeciesUuid: domain.forestMassSpeciesUuid,
  code: domain.code,
  diameter: domain.diameter,
  hrms: domain.hrms,
  vrms: domain.vrms,
  status: domain.status,
  position: domain.position,
  altitude: domain.altitude,
  utmX: domain.utmX,
  utmY: domain.utmY,
  appraiserWeight: domain.appraiserWeight * 1000,
  volumeUsc: domain.volumeUsc,
  volumeIfn: domain.volumeIfn,
});

export const toDomain = (dto: InventoryPLotDto): InventoryPlot => ({
  ...dto,
  appraiserWeight: dto.appraiserWeight / 1000,
});
